import { Checkbox } from 'antd'
import './ServicesBar.css'
import ServicesForm from '../ServicesForm/ServicesForm'

const ServicesBar = () => {

    return (
        <div className="services-bar-main-container" >
            <div className='services-bar-purple-row'>
                <div className='services-bar-text'>Hai bisogno di una soluzione personalizzata?</div>
                <a className='services-bar-white-link' href={`${process.env.REACT_APP_SITE_URL}/contatti/`}>
                    <button className='services-bar-white-button'>Richiedi Contatto</button>
                </a>
            </div>
            <ServicesForm></ServicesForm>
        </div>
    )
}

export default ServicesBar
